import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {map} from "rxjs/operators";
import {MailToService} from "../services/mail-to.service";
import {MAIL_TO_ACTION, MailToActions} from "../actions/mail-to-actions";

@Injectable()
export class MailToEffects {
  constructor(private actions$: Actions, private mailToService: MailToService) {}

  mailTo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<MailToActions>(MAIL_TO_ACTION),
        map((action) => {
          if (action.payload) {
            this.mailToService.mailTo(action.payload);
          }
        })
      ),
    { dispatch: false }
  );
}
